<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-classevaluate__evaluate-ranked">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getPage()">
                <el-form-item label="年级" prop="gradeId">
                    <el-select v-model="dataForm.gradeId"  placeholder="年级" clearable>
                        <el-option
                                v-for="grade in grades"
                                :key="grade.id"
                                :label="grade.title"
                                :value="grade.id">

                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-if="show"
                            @change="changeTime"
                            v-model="dataForm.selectTime"
                            type="month"
                            value-format="yyyy-MM"
                            :clearable="false"
                            placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getPage()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="weekScoreWorld()">{{ $t('export') }}</el-button>
                </el-form-item>
            </el-form>
            <el-table ref="table"
                    v-loading="dataListLoading"
                    :data="dataList"
                    height="740px"
                    border
                    @selection-change="dataListSelectionChangeHandle"
                    style="width: 100%"
                    :default-sort = "{prop: '总分', order: 'null'}"
            >
                <el-table-column
                        fixed
                        prop="className"
                        label="班级"
                        header-align="center"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        fixed
                        prop="headTeacherName"
                        label="班主任"
                        header-align="center"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        :prop="item.id"
                        v-for="(item, index) in typeList"
                        :key="index"
                        :label="item.examineTypeName"
                        header-align="center"
                        align="center"
                >
                    <template slot-scope="scope">{{scope.row.typeMap[item.id]}}</template>
                </el-table-column>
                <el-table-column
                        prop="totalScore"
                        label="得分"
                        header-align="center"
                        align="center"
                        sortable
                ></el-table-column>
                <el-table-column
                        prop="rank"
                        label="排名"
                        header-align="center"
                        align="center"
                        sortable
                ></el-table-column>
                <el-table-column
                        prop="className"
                        label="班级"
                        header-align="center"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="headTeacherName"
                        label="班主任"
                        header-align="center"
                        align="center"
                >
                </el-table-column>
               <!-- <el-table-column prop="isGetRed" label="流动红旗" header-align="center"
                                 align="center">
                    <template slot-scope="scope">
                        <img src="@/assets/img/redLog.png" v-if="isInArray(scope.row.classId)" style="height:24px;width: 24px;" alt="">
                    </template>
                </el-table-column>-->
            </el-table>
            <star-statistics-rule  v-if="starVisible" ref="starStatisticsRule" @refreshDataList="getPage()"></star-statistics-rule>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { gradeList } from '@/constant'
import { addDynamicRoute } from '@/router'
import qs from 'qs'
import Cookies from 'js-cookie'
import StarStatisticsRule from './star-statistics-rule'
import Template from '../devtools/template'
export default {
  components: { Template, StarStatisticsRule },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/classEvaluate/evaluateScore/monthAchievementsStatistics',
        getDataListIsPage: false,
        exportURL: '/classEvaluate/evaluateScore/export',
        createdIsNeed: false,
        activatedIsNeed: false
      },
      typeList: [],
      itemList: [],
      rollCallDate: [],
      redList: [],
      gradeList,
      scoreList: [],
      grades: [],
      dataForm: {
        selectTime: '',
        gradeId: ''
      },
      starVisible: false,
      weekVisible: false,
      show: false
    }
  },
  watch: {},
  created () {
    this.$nextTick(() => {
      var nowDate = new Date()
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      }
      var dayDate =
        date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month)
      this.show = true
      this.$set(this.dataForm, 'selectTime', dayDate.toString())
      console.log(this.dataForm.selectTime)
    })
  },
  mounted () {
    this.getPage()
    this.getGradeList()
    /*  */
  },
  methods: {
    getGradeList () {
      this.$http.get('grade/getList').then(async ({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.grades = res.data
      })
    },
    changeTime () {
      // console.log(11111111)
      // console.log(this.dataForm.selectTime)
      /* if (this.dataForm.selectTime !== null && this.dataForm.selectTime !== '') {
        this.dataForm.selectTime = this.gettime(this.dataForm.selectTime)
      } else {
        this.dataForm.selectTime = ''
      }
      // console.log(11111111) */
      console.log(this.dataForm.selectTime)
    },
    /** startTime: '', endTime: '',
     * 时间处理函数
     * */

    /* gettime (data) {
      /!* console.log(11111111)
      console.log(this.dataForm.selectTime) *!/
      const value = data.getFullYear() + '-' +
        this.checkTime(data.getMonth() + 1) /!* + '-' +
        this.checkTime(data.getDate()) + ' ' *!/
      /!* this.checkTime(data.getHours()) + ':' +
        this.checkTime(data.getMinutes()) + ':' +
        this.checkTime(data.getSeconds()) *!/
      return value
    }, */
    /**
     * 时间处理
     * 如果时间小于10 ，则再前面加一个'0'
     * */

    checkTime (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    getPage () {
      this.init()
    },
    async init () {
      const typeList = await this.getTypeList()
      console.log('类型列表', typeList)
      this.getInfoList()
      this.$refs.table.doLayout()
    },
    getInfoList () {
      this.dataListLoading = true
      this.$http
        .get(
          '/classEvaluate/evaluateScore/monthAchievementsStatistics', { params: { month: this.dataForm.selectTime, gradeId: this.dataForm.gradeId } }
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.dataListLoading = false
          this.dataList = data.data
        })
    },
    getTypeList () {
      return new Promise((resolve, reject) => {
        this.$http
          .post('classEvaluate/examineType/getExamineTypeList')
          .then(({ data: res }) => {
            if (res.code !== 0) {
              reject({
                msg: res.msg,
                data: res
              })
              return
            }
            this.typeList = res.data
            resolve(res.data)
          })
          .catch((err) => {
            reject({
              msg: '获取类型列表失败',
              data: err
            })
          })
      })
    },
    weekScoreWorld () {
      const params = qs.stringify({
        gradeId: this.dataForm.gradeId,
        month: this.dataForm.selectTime,
        token: Cookies.get('token')
      })
      window.open(`${window.SITE_CONFIG.apiURL}/classEvaluate/evaluateScore/exportAchievementsStatistics?${params}`)
    }
  }
}
</script>
